module.exports = __webpack_public_path__ + "static/media/available-icon.c82373ce.svg";